/* RESPONSIBLE TEAM: team-data-foundations */
import { requestHeaders } from 'embercom/lib/ajax';

export function submitOAuthForm(authorizationUrl: string): void {
  let form = document.createElement('form');
  form.method = 'POST';
  form.action = authorizationUrl;

  let csrfInput = document.createElement('input');
  csrfInput.type = 'hidden';
  csrfInput.name = 'authenticity_token';
  csrfInput.value = requestHeaders()['X-CSRF-Token'];
  form.appendChild(csrfInput);

  document.body.appendChild(form);
  form.submit();
}
